// Uppercase first letter of each word for table names
// exported for use in Dashboard
export function formatToPascalCase(name) {
  const arr = name.toLowerCase().split(' ')
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
  }
  return arr.join(' ')
}
